/*
 * fof/upload: o aviso "Enviando…" do editor,
 * com a barra de progresso. A extensão não informa a porcentagem (a
 * requisição é uma só), então a barra é indeterminada; ela some quando o
 * envio termina ou falha. O botão na barra de ferramentas é do editor.
 */
import { extend } from 'flarum/common/extend';
import TextEditor from 'flarum/common/components/TextEditor';
import { t } from '../utils/settings';
import { thirdParty } from './settings';
export default function installUpload() {
  extend(TextEditor.prototype, 'oncreate', function () {
    this.uploader?.on?.('uploading', files => {
      this.canelaUploadCount = files?.length || 1;
    });
  });
  extend(TextEditor.prototype, 'view', function (vdom) {
    if (!thirdParty.uploadProgress() || !this.uploader?.uploading || !vdom || !Array.isArray(vdom.children)) return;
    const count = this.canelaUploadCount || 1;
    vdom.children.push(m("div", {
      className: "CanelaUploadProgress",
      role: "status",
      "aria-live": "polite"
    }, m("span", {
      className: "CanelaUploadProgress-label"
    }, t('thirdparty.upload.uploading', {
      count
    })), m("span", {
      className: "CanelaUploadProgress-bar",
      "aria-hidden": "true"
    }, m("span", {
      className: "CanelaUploadProgress-fill"
    }))));
  });
}
flarum.reg.add('ramon-canela', 'forum/thirdparty/upload', installUpload);